"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Menu_1 = __importDefault(require("@material-ui/core/Menu"));
var core_1 = require("@material-ui/core");
var LinkButton_1 = __importDefault(require("../LinkButton"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return ({
        root: (_a = {},
            _a[theme.breakpoints.down('sm')] = {
                width: '100%',
            },
            _a)
    });
});
var BasicMenu = function (props) {
    var classes = useStyles();
    var menuName = props.menuName, linkChildren = props.linkChildren, children = props.children, onClick = props.onClick, onClose = props.onClose, anchorEl = props.anchorEl;
    return (react_1.default.createElement(core_1.Box, null,
        react_1.default.createElement(LinkButton_1.default, { linkName: menuName, href: '', linkChildren: linkChildren, isMenuLink: true, onClick: onClick }),
        react_1.default.createElement(Menu_1.default, { id: "basic-menu", PopoverClasses: {
                root: classes.root,
                paper: classes.root,
            }, anchorEl: anchorEl, keepMounted: true, elevation: 2, getContentAnchorEl: null, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'center',
            }, open: Boolean(anchorEl), onClose: onClose }, children)));
};
exports.default = BasicMenu;
